<template>
  <div>
    <div class="title-div">燃气报修及巡检详情</div>
    <div class="form-div" v-loading="loading">
      <el-form ref="form" :model="detail" label-width="80px" label-position="top" :rules="rules">
        <el-form-item label="用户编号：" prop="gasUserNumber">
          <el-input v-model="detail.gasUserNumber" placeholder="用户编号" readonly></el-input>
        </el-form-item>
        <el-form-item label="服务编号：" prop="serviceNumber">
          <el-input v-model="detail.serviceNumber" placeholder="服务编号" readonly></el-input>
        </el-form-item>
        <div class="state-div">
          <span class="state-span">状态：</span>
          <img src="../../../assets/pc/pcRepair/end.png" v-if="detail.repairState == '已完成'">
          <img src="../../../assets/pc/pcRepair/repairing.png" v-if="detail.repairState == '处理中'">
          <img src="../../../assets/pc/pcRepair/unfinished.png" v-if="detail.repairState == '未完成'">
          <span class="repair-state-span"
                :class="detail.repairState == '未完成' ? 'orange' : detail.repairState == '已完成' ? 'green' : 'blue'">
            {{detail.repairState}}
          </span>
        </div>
        <el-form-item label="联系电话：" prop="repairCall">
          <el-input v-model="detail.repairCall" placeholder="联系电话" readonly></el-input>
        </el-form-item>
        <el-form-item label="详细地址：" prop="detailedAddress">
          <el-input v-model="detail.detailedAddress" placeholder="详细地址" readonly type="textarea" autosize></el-input>
        </el-form-item>
        <el-form-item label="报修类型：" prop="repairTypeChina">
          <el-input v-model="detail.repairTypeChina" placeholder="报修类型" readonly></el-input>
        </el-form-item>
        <el-form-item label="用户备注：" prop="userNote">
          <el-input type="textarea"
                    autosize
                    v-model="detail.userNote"
                    placeholder="请详细描述维修对象、损坏情况等；如联系人不是报修人，请填写联系人和电话"
                    readonly>
          </el-input>
        </el-form-item>
        <!--<el-form-item v-if="isShowEvaluation || detail.feedBackCH" label="服务评价：" prop="feedBackCH">
          <el-select v-model="detail.feedBackCH" placeholder="请选择" class="feed-back-select"
                     :disabled="!isShowEvaluation">
            <el-option
              v-for="item in serviceEvaluationColumns"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="detail.feedBackCH == 'BJG UnSatis' || detail.feedBackDetailCH" label="为何不满意："
                      prop="feedBackDetailCH">
          <el-select v-model="detail.feedBackDetailCH" placeholder="请选择" class="feed-back-select"
                     :disabled="!isShowEvaluation">
            <el-option
              v-for="item in feedBackDetailColumns"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="isShowEvaluation">
          <el-button type="primary" class="submit-button" @click="submitEvaluate()">提交评价</el-button>
        </el-form-item>-->
      </el-form>
    </div>
  </div>
</template>

<script>
  import { evaluate } from '../../../api/repair'

  export default {
    name: 'PCRepairDetail',
    data () {
      return {
        detail: {
          gasUserNumber: '', // 用户编号
          serviceNumber: '', // 服务编号
          repairState: '', // 状态
          repairCall: '', // 联系电话
          detailedAddress: '', // 详细地址
          repairTypeChina: '', // 报修类型
          userNote: '', // 用户备注
          feedBackCH: '', // 服务评价
          feedBack: '', // 服务评价值
          feedBackDetailCH: '', // 为何不满意
          feedBackDetail: '', // 为何不满意值
          canFeedback: 'N' // 能否评价
        }, // 报修详情
        isShowEvaluation: true, // 是否显示提交评价按钮
        serviceEvaluationColumns: [{
          label: '满意',
          value: 'BJG VerySatis'
        }, {
          label: '一般',
          value: 'BJG Satis'
        }, {
          label: '不满意',
          value: 'BJG UnSatis'
        }], // 服务评价列表
        feedBackDetailColumns: [{
          label: '态度不满意',
          value: 'BJG Attitude'
        }, {
          label: '收费不满意',
          value: 'BJG Fee'
        }, {
          label: '时间不满意',
          value: 'BJG Time'
        }, {
          label: '服务不满意',
          value: 'BJG Service'
        }, {
          label: '技术不满意',
          value: 'BJG Tech'
        }, {
          label: '其他不满意',
          value: 'BJG OtherUnSatis'
        }], // 为何不满意列表
        loading: false, // 是否显示加载提示
        rules: {
          feedBackCH: [
            {
              required: true,
              message: '请选择您对此次服务的评价',
              trigger: 'change'
            }
          ],
          feedBackDetailCH: [
            {
              required: true,
              message: '请选择不满意原因',
              trigger: 'change'
            }
          ]
        } // 校验规则
      }
    },
    mounted () {
      this.detail = this.$route.params.detail
      /*if (this.$route.params.detail.canFeedback === 'N') {
        this.isShowEvaluation = false
        if (this.$route.params.detail.feedBack) {
          this.detail.feedBackCH = this.$route.params.detail.feedBack
        }
        if (this.$route.params.detail.feedBackDetail) {
          this.detail.feedBackDetailCH = this.$route.params.detail.feedBackDetail
        }
      } else {
        this.isShowEvaluation = true
      }*/
    },
    methods: {
      // 提交评价
      submitEvaluate () {
        const that = this
        that.$refs['form'].validate((valid) => {
          if (valid) {
            that.loading = true
            const params = {
              srnum: that.detail.serviceNumber,
              feedback: that.detail.feedBackCH,
              feedbackDetail: that.detail.feedBackDetailCH
            }
            if (that.detail.feedBackCH !== 'BJG UnSatis') {
              params.feedbackDetail = ''
            }
            evaluate(params).then(res => {
              that.loading = false
              if (res.data.success) {
                that.detail.canFeedback = 'N'
                that.isShowEvaluation = false
                this.$message({
                  message: res.data.message,
                  type: 'success'
                });
              } else {
                that.$message.error(res.data.message ? res.data.message : '返回数据异常');
              }
            }).catch(() => {
              that.loading = false
              that.$message.error('请求评价异常');
            })
          } else {
            return false
          }
        })
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .form-div {
    padding: 47px 40% 57px 40%;
  }

  .submit-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  .register-button {
    width: 100%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
    height: 40px;
    padding: 0;
  }

  /deep/ .el-form--label-top .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #BD1A2D;
    color: #BD1A2D;
  }

  .state-span {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .state-div {
    margin-bottom: 20px;
  }

  .repair-state-span {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    vertical-align: text-bottom;
  }

  .orange {
    color: #FF6B38;
  }

  .green {
    color: #04B08F;
  }

  .blue {
    color: #004FDF;
  }

  .feed-back-select {
    width: 100%;
  }
</style>

